import { render, staticRenderFns } from "./PrintFooter.vue?vue&type=template&id=15f6f73b&scoped=true"
import script from "./PrintFooter.vue?vue&type=script&lang=js"
export * from "./PrintFooter.vue?vue&type=script&lang=js"
import style0 from "./PrintFooter.vue?vue&type=style&index=0&id=15f6f73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6f73b",
  null
  
)

export default component.exports